import React from "react";

function Header() {
  return (
    <header>
      <h1>Super paper</h1>
    </header>
  );
}

export default Header;
